module.exports = __webpack_public_path__ + "img/bottom-background.93f45732.png";